const ShareActions = ({ onShare, isLoading }) => {
    return (
        <>
            <div className="shareActions">
                <button 
                    className="actionButton feed"
                    onClick={onShare}
                    disabled={isLoading}
                >
                    {isLoading ? "Sharing..." : "Share to Feed"}
                </button>

                <button className="actionButton message">
                    Send as Message
                </button>
            </div>

            <div className="otherOptions">
                <span>
                    Or share via:
                </span>

                <div className="icons">
                    <div className="icon">FB</div>

                    <div className="icon">TW</div>

                    <div className="icon">WA</div>

                    <div className="icon">Link</div>
                </div>
            </div>
        </>
    );
};

export default ShareActions;